import { handleError, handleLongText } from 'config/libraries';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

export const RelateContent = ({category_id}) => {
    
    const [DataResponse, setDataResponse] = useState([]);

    useEffect(() => {
        const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/berita?per_page=4&page=1&id_kategori_berita=' + category_id).then(function (response) {
            setDataResponse(response.data.data.data);
        }).catch(function (error) {
            handleError(error)
        })
        return () => {
            setDataResponse(null);
        };
    }, [category_id]);

    return (
        <div className="related-posts">
            <h4>Berita Terkait</h4>
            <div className="single_related_post">
                {
                    DataResponse && DataResponse.map((item, index) => {
                        return (
                            <div className="jl_m_right jl_m_list jl_m_img">
                                <div className="jl_m_right_w">
                                    <div className="jl_m_right_img jl_radus_e">
                                        <Link to={'/berita/' + item.slug_berita}>
                                            <img width={500} height={350} src={process.env.REACT_APP_SERVER_IMAGE_URL + item.gambar_berita} className="attachment-sprasa_slider_grid_small size-sprasa_slider_grid_small wp-post-image" alt="" loading="lazy" />
                                        </Link>
                                    </div>
                                    <div className="jl_m_right_content">
                                        <span className="jl_f_cat">
                                            <Link to={'/berita/' + item.slug_berita} className="post-category-color-text" style={{background: '#eba845'}}>{item.nama_kategori_berita}</Link>
                                        </span>
                                        <h2 className="entry-title">
                                            <Link to={'/berita/' + item.slug_berita} tabIndex={-1}>{handleLongText(item.judul_berita, 50)}</Link>
                                        </h2>
                                        <span className="jl_post_meta">
                                            <span className="jl_author_img_w">
                                                <span className="post-date">
                                                    <i className="jli-pen" />{item.created_at}
                                                </span>
                                            </span>
                                        </span>
                                        <Link to={'/berita/' + item.slug_berita}>
                                            <p>{handleLongText(item.sub_judul_berita, 137)}</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )
                    })
                }
               
            </div>
        </div>
    )
};